import { Button, Input } from "@material-ui/core";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { currencySelector } from "../../../redux/currencyReducer";
import { useModifyPaymentsBalanceMutation } from "../../../api/reports";

interface ModifyFormProps {
  service: string;
  balances: { [currency: string]: string | number; };
}

const ModifyForm: React.FC<ModifyFormProps> = ({ service, balances }) => {
  const [state, setState] = useState<null | "add" | "sub">(null);
  const [value, setValue] = useState<number>(0);
  const [currency, setCurrency] = useState("");
  const { items: currencyList } = useSelector(currencySelector);
  const [modify, { isLoading }] = useModifyPaymentsBalanceMutation();
  if (state === null) {
    return <div style={{ display: "flex", gap: "2px" }}>
      <Button variant="contained" color="primary" onClick={() => setState("add")}>Ввод</Button>
      <Button variant="contained" color="primary" onClick={() => setState("sub")}>Вывод</Button>
    </div>;
  }
  return <div style={{ display: "flex", gap: "2px" }}>
    <Input type="number" value={value} onChange={(e) => setValue(Number(e.target.value))} />
    <select value={currency} onChange={(e) => setCurrency(e.target.value)}>
      <option value=""></option>
      {currencyList.map(currency => <option key={currency.id} value={currency.id}>{currency.id}</option>)}
    </select>
    <Button disabled={value <= 0 || !currency || isLoading || (state === "sub" && (!(currency in balances) || +balances[currency] < value))} variant="contained" color="primary" onClick={() => { modify({ service, amount: value * (state === "sub" ? -1 : 1), currency }); setState(null); }}>{state === "add" ? "Ввести" : "Вывести"}</Button>
    <Button variant="contained" color="primary" onClick={() => setState(null)}>Отмена</Button>
  </div>
}

export default ModifyForm;
